import { classnames } from 'tailwindcss-classnames';

import {
  ArticleHit,
  EmployeeHit,
  EventHit,
  EventListingHit,
  FileHit,
  PageHit,
  AnnouncementListingHit,
  ReportsHit,
  SearchListingHit,
  FeeScheduleHit,
  ProductListHit,
} from '../Hits';
import { HitProps } from '../Hits/_types';

const mapping = {
  employee: EmployeeHit,
  other: PageHit,
  event: EventHit,
  file: FileHit,
  article: ArticleHit,
  eventListing: EventListingHit,
  announcementListing: AnnouncementListingHit,
  report: ReportsHit,
  searchListing: SearchListingHit,
  feeSchedule: FeeScheduleHit,
  productList: ProductListHit,
};

const NrcSearchHit = ({ hit, component }: HitProps) => {
  const Component = mapping[component || hit.type] || PageHit;
  if (component === 'productList') {
    return (
      <div>
        <Component hit={hit} />
      </div>
    );
  }
  return (
    <div className={classnames('py-6', 'px-6', 'md:px-10')}>
      <Component hit={hit} />
    </div>
  );
};

export default NrcSearchHit;
